module.exports = "/images/picture.svg?157b8b9ec86f8006672fa58ba0192c98";